import styled from '@emotion/styled';
import { SmallText, Text } from 'ds/components/typography';

export const Root = styled.div(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(2.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: theme.colors.brand.lightBlue,
  boxShadow: '-1px 0px 0px 0px rgba(0, 0, 0, 0.12), 0px -1px 0px 0px rgba(0, 0, 0, 0.12)',
  'button, a': {
    maxWidth: '200px',
    width: '100%',
  },
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    padding: theme.spacing(2),
  },
}));

export const AgentName = styled(Text)(({ theme }) => ({
  color: theme.colors.brand.main,
}));

export const AgentText = styled(SmallText.withComponent('span'))(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const AgentTextDivide = styled(AgentText)(({ theme }) => ({
  margin: theme.spacing(0, .5),
  '::after': {
    display: 'inline',
    content: '"•"',
  },
}));

export const Details = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  gap: theme.spacing(1.5),
}));

export const ButtonWrapper = styled.div<{ justifyContent: boolean }>(({ theme, justifyContent }) => ({
  flexShrink: 0,
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  whiteSpace: 'nowrap',
  justifyContent: justifyContent ? 'space-between' : 'flex-start',
  flexGrow: justifyContent ? 1 : 0,
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    'a, button': {
      maxWidth: '168px',
      width: '100%',
    },
    'button:disabled': {
      maxWidth: '230px',
    },
  },
}));

export const Texts = styled.div({
  'a': {
    textDecoration: 'none',
  },
});
